import service from '@/service/request';
import config from '../config';

const defaultHost = config.marketApi.apiHost;
const blackHost = config.blackHost;
const appId = config.orchard.appId;

const getData = ret => {
  if (ret.status === 200 && (ret.data.code === 200 || ret.data.code === 0)) {
    return {
      isSuccess: true,
      data: ret.data.data,
      msg: null,
    };
  }
  return {
    isSuccess: false,
    code: ret.data.code,
    msg: ret.data.msg,
  };
};

const gtValidate = data => service
  .post(`${defaultHost}/activity/risk/api/v1_0/validate`, {
    appId,
    ...data,
  }, {
    headers: {
      'risk-uuid': data.unique,
    },
  }).then(ret => getData(ret));


const getGtInitData = () => service
  .post(`${defaultHost}/activity/risk/api/v1_0/register`, {
    clientType: 2, // 客户类型
  }).then(ret => getData(ret));

export {
  getGtInitData,
  gtValidate,
};
